import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate, useParams } from "react-router-dom";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { confirmSubscriptionAction } from "../actions/restaurantActions";
import { fetchSubscriptionStatus } from "../actions/paymentActions";
import styled from "styled-components";
import { ConfirmationModal } from "./DefaultImports";

const stripePromise = loadStripe(
  "pk_test_51OHTqdGwmqMQdn7MI69vIxvTMioVBA1EdYU78d6peZcznJt6r0X2Ck0cId43DCnOsX3whaGRGreLy6IhQsn7seGE00yaWQTNDf",
);

const PaymentWrapper = styled.form`
  max-width: 100%;
  padding: 24px;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  font-family: "Kanit", sans-serif;
`;

const PaymentHeader = styled.div`
  font-size: 22px;
  font-weight: bold;
  color: #99b0ad;
  margin-bottom: 24px;
  text-align: center;
`;

const SubmitButton = styled.button`
  background-color: #ee754c;
  color: white;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  margin-top: 20px;
  width: 100%;
  transition: background 0.3s;

  &:hover {
    background-color: #ee561b;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  color: #dc3545;
  margin-top: 12px;
  text-align: center;
  font-size: 14px;
`;

const CheckoutForm = ({
  subscription_number,
  restaurant_id,
  _setIsConfirmationModal,
  isUpdate,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();

  const params = useParams();

  const [errorMessage, setErrorMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isPaid, setIsPaid] = useState(false);

  const { isLoadingConfirmSubscription, confirmSubscription } = useSelector(
    (state) => state.paymentIntent,
  );
  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants } = restaurantDetails;

  useEffect(() => {
    console.log(
      "setIsConfirmationModal in CheckoutForm is:",
      _setIsConfirmationModal,
    );
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(null);

    if (!stripe || !elements) return;

    const card = elements.getElement(CardElement);
    setIsSubmitting(true);

    try {
      // 1) Create a PaymentMethod from the card
      const { paymentMethod, error: pmError } =
        await stripe.createPaymentMethod({
          type: "card",
          card,
        });
      if (pmError) {
        setErrorMessage(pmError.message);
        return;
      }

      // 2) Ask backend to create the subscription; it returns clientSecret (no-trial) or null (trial)
      const {
        subscription_id,
        status,
        clientSecret,
        invoice_id,
        payment_intent_id,
      } = await dispatch(
        confirmSubscriptionAction(
          restaurant_id,
          subscription_number,
          paymentMethod.id,
          true,
          isUpdate,
        ),
      );

      console.log("[subscribe]", {
        subscription_id,
        status,
        invoice_id,
        payment_intent_id,
        hasClientSecret: !!clientSecret,
      });

      // 3) If there is a clientSecret (no-trial path), confirm the invoice PI
      if (clientSecret) {
        // Server already attached the PM to the PI, so no need to pass payment_method again

        const { error: confirmError, paymentIntent } =
          await stripe.confirmCardPayment(clientSecret);

        if (confirmError) {
          // Optional smart retry: if server didn’t attach PM for some reason, try with the PM you created
          const retry = await stripe.confirmCardPayment(clientSecret, {
            payment_method: paymentMethod.id,
          });
          if (retry.error) {
            console.error("[confirmCardPayment] failed:", retry.error);
            setErrorMessage(
              retry.error.message || "Payment confirmation failed.",
            );
            return;
          }
          console.log(
            "[confirmCardPayment] retry status:",
            retry.paymentIntent?.status,
          );
        } else {
        }
      } else if (status !== "false") {
      } else {
      }
      const data = await dispatch(fetchSubscriptionStatus({ restaurant_id }));

      setIsPaid(true);

      if (data.status === "trialing" || data.status === "active") {
        _setIsConfirmationModal(true);
      }

      // Success UX here (navigate / toast)
      //
    } catch (err) {
      console.error(err);
      setErrorMessage(err?.message || "Unexpected error.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PaymentWrapper onSubmit={handleSubmit}>
      <PaymentHeader>Dados para pagamento</PaymentHeader>

      <CardElement
        options={{
          style: {
            base: {
              fontSize: "17px",
              fontFamily: '"Kanit", sans-serif',
              color: "#424770",
              "::placeholder": { color: "#aab7c4" },
            },
            invalid: { color: "#9e2146" },
          },
        }}
      />

      <SubmitButton type="submit" disabled={!stripe || isSubmitting}>
        {isSubmitting ? "A processar..." : "Subscrever"}
      </SubmitButton>

      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </PaymentWrapper>
  );
};

const StripeCreatePayMethod = ({
  subscription_number,
  restaurant_id,
  handleSetConfirmation,
  isUpdate,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Elements stripe={stripePromise}>
        <CheckoutForm
          restaurant_id={restaurant_id}
          subscription_number={subscription_number}
          _setIsConfirmationModal={handleSetConfirmation}
          isUpdate={isUpdate}
        />
      </Elements>
    </>
  );
};

export default StripeCreatePayMethod;
